import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
  Span,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white>
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px">Rensning af anlæg, der er sjældent brugt</Heading1>
                  <hr />
                  <Div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <Paragraph>
                      <Bold>Spørgsmål 1</Bold>: <Span itemprop="name">Skal der renses både før og efter brug, når anlægget f.eks. bliver brugt hvert halve år?</Span>
                    </Paragraph>
                    <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                      <Paragraph italic>
                        - Når du bruger det med så store intervaller så anbefaler vi at du renser det umiddelbart før brug.
                        Det betyder at i den mellemliggende periode skal det stå med øl i slangerne.
                      </Paragraph>
                      <Paragraph italic>
                        Alternativt, så renser du det efter brug og sørger for at øl slangerne bliver tømt for skyllevand efter rensningen.
                        Dette kan gøres ved at lade rensedunken løbe helt tør, så kulsyren blæser vandet ud af slangerne.
                        Så står anlægget altså med luft i slangerne i den mellemliggende periode.
                      </Paragraph>
                    </Div>
                  </Div>
                  <hr />
                  <Div itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
                    <Paragraph>
                      <Bold>Spørgsmål 2</Bold>: <Span itemprop="name">Når rensevæsken er i beholderen, skal der så kulsyre på, så der er tryk til at presse væsken ud af hanen?</Span>
                      Kan læse at køleren skal være slukket.
                    </Paragraph>
                    <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                      <Paragraph italic>
                        - Ja, det skal der.
                      </Paragraph>
                      <Paragraph italic>
                        Alternativt kan man bruge trykluft eller en hvilken som helst anden komprimeret gasart.
                        Når anlægget er renset, og derefter skal skylles med rent vand, kan dette gøre ved tilslutning direkte til vandhanen (så bruges vandtrykket i stedet for kulsyren).
                      </Paragraph>
                    </Div>
                  </Div>
                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
